import CtaRepository from "../CtaRepository"

export default class PricingCtaButton extends CtaRepository {
    static schemaId = "pricing_requestDemoButton"

    constructor() {
        super(PricingCtaButton.schemaId)
    }
}
